import { service } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import Serviced from 'webapp/models-custom/serviced';
import type SourceType from 'webapp/models-custom/source-type';

export interface BoardFromAnotherSpaceData {
	id: number;
	spaceId: number;
	name: string;
	sourceTypes: number[];
	image: string;
	created: number;
	createdByName: string;
	allSourceTypesAvailable: boolean;
	modified?: number;
	modifiedByName?: string;
}

export default class BoardFromAnotherSpace extends Serviced {
	@service('model-manager/source-types')
	declare mmSourceTypesService: Service.ModelManager.SourceTypes;
	@service('model-manager/spaces') declare mmSpacesService: Service.ModelManager.Spaces;

	@tracked animationClass = '';

	id: number;
	spaceId: number;
	name: string;
	sourceTypeIds: number[];
	image: string;
	created: number;
	createdByName: string;
	modified: number | null;
	modifiedByName: string;
	allSourceTypesAvailable: boolean; // shows warning if target has no source (and there are no generic support for cq / scripts yet)

	constructor(item: BoardFromAnotherSpaceData) {
		super();
		this.id = item.id;
		this.spaceId = item.spaceId;
		this.name = item.name;
		this.sourceTypeIds = item.sourceTypes || [];
		this.image = item.image;
		this.created = item.created;
		this.createdByName = item.createdByName;
		this.modified = item.modified || null;
		this.modifiedByName = item.modifiedByName || '';
		this.allSourceTypesAvailable = !!item.allSourceTypesAvailable;
	}

	@cached
	get sourceTypes() {
		const sourceTypes: SourceType[] = [];
		this.sourceTypeIds.forEach((sourceTypeId) => {
			const sourceType = this.mmSourceTypesService.findModelById(sourceTypeId);
			if (sourceType) {
				sourceTypes.push(sourceType);
			}
		});
		return sourceTypes;
	}

	get accountName() {
		// for showing in the table
		const space = this.mmSpacesService.findModel(String(this.spaceId));
		return space?.companyName;
	}

	@cached
	get sourcesList() {
		// for showing in the table
		return this.sourceTypes.map((sourceType) => {
			return {
				avatar: sourceType.avatar,
				label: sourceType.name,
			};
		});
	}
}
